


$_GP.grid = {}

const _chunk = (size, arr)=> {
	var results = [];

	while (arr.length) {
		results.push(arr.splice(0, size));
	}

	return results;
}

const _rand = (min,max)=> {
	return Math.floor(Math.random()*(max-min+1)+min);
}

const _randDifPrevious = (min,max)=> {
	let prev = max
	return function randFn() {
		const r = _rand(min,max);
		if ( r === prev) {
			return randFn()
		} else {
			prev = r
			return r
		}
	}
}

// const _randDif3 = _randDifPrevious(0,3)
// Array.from(Array(40)).forEach(()=> {
// 	console.log(_randDif3())
// })

const loopRebbot = (max)=> {
	const start = 0
	let count = 0
	return {
		inc() {
			if (count > max) count = 0
			return count++
		}
	}
}

const onScroll = (elm, fn )=> {
	return (ev)=> {
		const distTop      = $(window).scrollTop()

		const windowHeight = window.innerHeight;
		const elmHeight    = elm.height()
		const elmDistTop   = elm.offset().top
		const trigger = (elmDistTop + elmHeight) - (windowHeight + 200)
		if (distTop > trigger) {
			fn()
		}
	}
}

$_GP.grid.parseData = function(data, opt={}) {
	data = data.concat([])
	opt.firstChunck = opt.firstChunck || 3
	opt.chunks = opt.chunks || 2

	let NEW_DATA = []

	if (data.length <= opt.firstChunck) {
		NEW_DATA = _chunk(opt.firstChunck, data)
	} else {
		let top = data.splice(0, opt.firstChunck)
		let bottom = _chunk(opt.chunks, data)
		NEW_DATA.push(top)
		NEW_DATA = NEW_DATA.concat(bottom)
	}

	return NEW_DATA
}

$_GP.grid.run = function(elm, options={}) {
	elm = $(elm);
	if (!elm.length) return;

	const defaults = {
		postIncrementName: 'counter',
		postExtraData: {}
	}
	const opt = $.extend({}, defaults, options)

	if (!opt.url) {
		console.error('url/to/endpoint is requrired!')
		return;
	}

	const postData = opt.postExtraData
	postData[opt.postIncrementName] = -1

	let HAS_TEMPLATES = true
	const templates = $_GP.grid.templates(opt)

	const addTemplates = function(allTemplates) {
		if (!HAS_TEMPLATES) return
		postData[opt.postIncrementName] +=1

		const $ajax = $_GP.ajax(opt.url, postData).done(function(resp) {
			if (!resp) {
				HAS_TEMPLATES = false
				if (allTemplates) allTemplates()
				return
			}

			const data = $_GP.grid.parseData(resp.data)
			const _randDif3 = _randDifPrevious(0,3)

			const html = data.reduce((acc, arr)=> {
				const len = arr.length
				if (len === 3) {
					acc.push(templates.grid_3[_rand(0,1)](arr))
				} else if (len == 1) {
					acc.push(templates.grid_1[0](arr))
				} else {
					acc.push(templates.grid_2[_randDif3()](arr))
				}

				return acc
			}, []).join('')

			elm.append(html)

			if (!resp.hasMore) {
				HAS_TEMPLATES = false
				if (allTemplates) allTemplates()
			}
		});

		if (opt.$ajax) opt.$ajax(elm, $ajax)
	}


	if (HAS_TEMPLATES && opt.loadOn === 'scroll load') {
		addTemplates()
		$(window).on('scroll', $_GP._.throttle(onScroll(elm, addTemplates)))
	}

	if (HAS_TEMPLATES && opt.loadOn === 'scroll') {
		$(window).on('scroll', $_GP._.throttle(onScroll(elm, addTemplates)))
	}

	if (HAS_TEMPLATES && opt.loadOn === 'click load') {
		addTemplates()
		$('#'+ elm.attr('id') +'-btn-load').on('click', function(ev) {
			addTemplates(()=> $(this).addClass('d-n'))
		})
	}
};

$_GP.grid.templates = function(opt) {
	const imgBlock = opt.imageTpl || function(data) {
		let cats = ''

		if (data.categories && data.categories.length) {
			cats = `
				<div class="grid-link-cats m-b-0 tt-u">
					${data.categories.map((cat)=> `<a href="${cat.url}">${cat.label}</a>` ).join(', ')}
				</div>
			`
		}

		return `
			<div class="grid-links" tabindex="0">
				<a class="grid-link" href="${data.url}">
					<div class="grid-link-img">
						<img class="img-responsive" src="${data.imgUrl}" alt="">
					</div>
				</a>
				<div class="grid-link-caption">
					<h3 class="grid-link-title h2 m-b-0">${data.title}</h3>
					${cats}
				</div>
			</div>
		`;
	}

	const grid_1_1 = function(data) {
		return `
			<div class="row grid-1-1">
				<div class="col-md-6">
					<div class="grid-item grid-item-3x2">
						${imgBlock(data[0])}
					</div>
				</div>

				<div class="col-md-6 hidden-sm">
					<div class="row">
						<div class="col-md-4">
							<div class="grid-item grid-item-1x1 bg-violet"></div>
						</div>
						<div class="col-md-4">
							<div class="grid-item grid-item-1x1 bg-brand"></div>
						</div>
						<div class="col-md-4">
							<div class="grid-item grid-item-1x1 bg-orange"></div>
						</div>
						<div class="col-md-4">
							<div class="grid-item grid-item-1x1 bg-blue"></div>
						</div>
						<div class="col-md-4">
							<div class="grid-item grid-item-1x1 bg-orange"></div>
						</div>
						<div class="col-md-4">
							<div class="grid-item grid-item-1x1 bg-violet"></div>
						</div>
					</div>
				</div>
			</div>
		`;
	}

	const grid_2_1 = function(data) {
		return `
			<div class="row grid-2-1">
				<div class="col-md-6">
					<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-orange"></div></div>
					<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-violet"></div></div>
					<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-brand"></div></div>
					<div class="col-sm-8">
						<div class="grid-item grid-item-2x1">
							${imgBlock(data[0])}
						</div>
					</div>
					<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-blue"></div></div>
				</div>

				<div class="col-md-6">
					<div class="grid-item grid-item-3x2">
						${imgBlock(data[1])}
					</div>
				</div>
			</div>
		`;
	}

	const grid_2_2 = function(data) {
		return `
			<div class="row grid-2-2">
				<div class="col-md-6">
					<div class="grid-item grid-item-3x2">
						${imgBlock(data[1])}
					</div>
				</div>

				<div class="col-md-6">
					<div class="row">
						<div class="col-md-8">
							<div class="grid-item grid-item-2x2">
								${imgBlock(data[0])}
							</div>
						</div>

						<div class="col-md-4 hidden-sm">
							<div class="grid-item grid-item-1x1 bg-violet"></div>
							<div class="grid-item grid-item-1x1 bg-orange"></div>
						</div>
					</div>
				</div>
			</div>
		`;
	}

	const grid_2_3 = function(data) {
		return `
			<div class="row grid-2-3">
				<div class="col-md-6">
					<div class="row">
						<div class="col-md-4 hidden-sm">
							<div class="grid-item grid-item-1x1 bg-blue"></div>
							<div class="grid-item grid-item-1x1 bg-orange"></div>
						</div>

						<div class="col-md-8">
							<div class="grid-item grid-item-2x2">
								${imgBlock(data[0])}
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-violet"></div></div>
					<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-blue"></div></div>
					<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-brand"></div></div>
					<div class="col-sm-12">
						<div class="grid-item grid-item-3x1">
							${imgBlock(data[1])}
						</div>
					</div>
				</div>
			</div>
		`;
	}

	const grid_2_4 = function(data) {
		return `
			<div class="row grid-2-4">
				<div class="col-md-6">
					<div class="grid-item grid-item-3x2">
						${imgBlock(data[0])}
					</div>
				</div>

				<div class="col-md-6">
					<div class="row">
						<div class="col-md-4 hidden-sm">
							<div class="grid-item grid-item-1x1 bg-brand"></div>
							<div class="grid-item grid-item-1x1 bg-orange"></div>
						</div>

						<div class="col-md-8">
							<div class="grid-item grid-item-2x2">
								${imgBlock(data[1])}
							</div>
						</div>
					</div>
				</div>
			</div>
		`;
	}

	const grid_3_1 = function(data) {
		return `
			<div class="row grid-3-1">
				<div class="col-md-6">
					<div class="row">
						<div class="col-sm-8">
							<div class="grid-item grid-item-2x1">
								${imgBlock(data[0])}
							</div>
						</div>

						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-orange"></div></div>
						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-blue"></div></div>

						<div class="col-sm-8">
							<div class="grid-item grid-item-2x1">
								${imgBlock(data[1])}
							</div>
						</div>
					</div>
				</div>

				<div class="col-md-6">
					<div class="grid-item grid-item-3x2">
						${imgBlock(data[2])}
					</div>
				</div>
			</div>
		`;
	}

	const grid_3_2 = function(data) {
		return `
			<div class="row grid-3-2">
				<div class="col-md-6">
					<div class="grid-item grid-item-3x2">
						${imgBlock(data[0])}
					</div>
				</div>

				<div class="col-md-6">
					<div class="row">
						<div class="col-sm-12">
							<div class="grid-item grid-item-3x1">
								${imgBlock(data[1])}
							</div>
						</div>

						<div class="col-sm-4"><div class="grid-item grid-item-1x1 bg-orange"></div></div>

						<div class="col-sm-8">
							<div class="grid-item grid-item-2x1">
								${imgBlock(data[2])}
							</div>
						</div>
					</div>
				</div>
			</div>
		`;
	}

	return {
		grid_1: [grid_1_1],
		grid_2: [grid_2_1, grid_2_2, grid_2_3, grid_2_4,],
		grid_3: [grid_3_1, grid_3_2],
	}
}
